class FrontendException extends Error {
  constructor(message) {
    super(message);
    this.name = 'FrontendException';
  }
}

export default FrontendException;
